import DataTableView from "@components/views/datatable-view";
import LoadingButton from "@components/ui-components/loading-button";
import UpsertUser from "./upsert";
import usePageChange from "@hooks/use-page-change";
import useUsers from "./use-users";
const Users = () => {

    const {
        data: { users = [], pagination = {} },
        loading,
        columns,
        setQueryParams,
        modalConfig,
        handleModalConfig,
        getUsers
    } = useUsers();

    /* A custom hook that is used to handle the pagination. */
    const { handlePageChange, handlePerRowsChange } = usePageChange({
        setQueryParams
    });

    return (
        <>
            <DataTableView
                moduleName="Users"
                breadcrumbItems={{
                    items: [
                        {
                            title : "Users",
                            active: true
                        }
                    ]
                }}
                loading={loading}
                tableProps={{
                    data: users,
                    columns,
                    handlePageChange,
                    handlePerRowsChange,
                    pagination
                }}
                actionItems={
                    <LoadingButton
                        color="primary"
                        icon="plus"
                        onClick={() => handleModalConfig()}
                        subject="users"
                        text="Add User"/>
                }/>
            <UpsertUser
                handleModalConfig={handleModalConfig}
                modalConfig={modalConfig}
                getUsers={getUsers}/>
        </>
    );
};

export default Users;
